import { DASHBOARD_TABS, type DashboardTab } from "./DashboardOverlay";

interface DashboardPillBarProps {
  onOpenTab: (slug: DashboardTab) => void;
}

export function DashboardPillBar({ onOpenTab }: DashboardPillBarProps) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {DASHBOARD_TABS.map((t) => (
        <button
          key={t.slug}
          type="button"
          onClick={() => onOpenTab(t.slug)}
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm border border-muted/60 bg-card hover:bg-muted/40 transition-colors"
        >
          <t.icon className="h-3.5 w-3.5 text-muted-foreground" />
          <span>{t.label}</span>
        </button>
      ))}
    </div>
  );
}
